import React from 'react';
import LoaderIcon from '../icons/LoaderIcon';

const Loader = () => {
  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    spinner: {
      animation: 'spin 0.5s linear infinite',
      transformOrigin: 'center center',
      height: 24,
      width: 24,
    },
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
      <div style={styles.spinner}>
        <LoaderIcon />
      </div>
    </div>
  );
};

export default Loader;
